import { render } from "./BackgroundMusic.vue?vue&type=template&id=4ddcda9c&scoped=true"
import script from "./BackgroundMusic.vue?vue&type=script&lang=js"
export * from "./BackgroundMusic.vue?vue&type=script&lang=js"

import "./BackgroundMusic.vue?vue&type=style&index=0&id=4ddcda9c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddcda9c"]])

export default __exports__